/**
 * Выбирает множественную форму русского языка в зависимости от переданного числа `amount`
 * @param {Number} amount целое число
 * @param {Array} variants варианты, например ['экскурсия', 'экскурсии', 'экскурсий']
 * @return {String}
 */
export const choosePlural = (amount: number, variants: string | string[]): string => {
  let [_amount, _variants] = [amount, variants];
  if (typeof variants === 'string') {
    _variants = variants.split(' ');
  }
  if (!amount) {
    _amount = 0;
  }
  const floored = Math.floor(_amount);

  if (_amount !== floored) {
    if (floored === 1) {
      return _variants[1];
    }

    return choosePlural(floored, _variants);
  }

  if (_amount % 10 === 1 && _amount % 100 !== 11) {
    return _variants[0];
  }
  if (_amount % 10 >= 2 && _amount % 10 <= 4 && (_amount % 100 < 10 || _amount % 100 >= 20)) {
    return _variants[1];
  }

  return _variants[2];
};
